import React from 'react';
import fr from 'facet-rest';
import {
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import {
  useBuildCommonFQEventProperties,
} from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';

const BackButton = ({ setLink }) => {
  const { resource } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  return resource.withRelationship(fr.relationships.previousQuestion.name, (rel) => {
    return (
      <FDStack justifyContent={'center'}>
        <FDTextButton
          data-test={'wellness-quiz-back-button'}
          onClick={() => {
            logStandardizedEvent(categories.facetQuiz, eventTypes.question, eventSubTypes.goBack, {
              eventProperties: {
                ...buildCommonFQEventProperties(resource),
                sectionId: resource.attr('sectionId'),
                questionId: resource.attr('questionId'),
              },
            });
            setLink(rel.link('related'));
          }}
          label={rel.meta('prompt')}
          size={'sm'}
        />
      </FDStack>
    );
  }, () => null);
};

BackButton.propTypes = {
  setLink: PropTypes.func.isRequired,
};

export { BackButton };
